<!--
* @description:
* @author: bin
* @date: 2022-09-26 16:09
-->
<template>
  <plmDownLoad v-bind="$attrs" v-on="$listeners" ref="downLoad"></plmDownLoad>
</template>

<script>
import plmDownLoad from './plm-downLoad'
export default {
  name: 'ExportModal',
  inheritAttrs: false,
  components: { plmDownLoad },
  data () {
    return {}
  },
  methods: {
    openModal (parmas) {
      this.$refs.downLoad.openModal(parmas)
    }
  }
}
</script>
